"use client";

import { Button, Text } from "@zapier/design-system";
import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  return (
    <div>
      <div className="not_found">
        <Text tag="h1" textAlign="center" type="SectionHeader">
          404: Page Not Found
        </Text>
        <Text tag="p" textAlign="center">
          Not all who wander are lost...but you are.
        </Text>
        <Button variant="primary" onPress={() => router.push("/")}>
          Back to safety
        </Button>
      </div>
    </div>
  );
}
